/* Sura — main navigation (<sura-menu>) */
if (!customElements.get('sura-menu')) {
  class SuraMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.sura-menu__item--parent'));
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.items.forEach((item) => {
        const toggle = item.querySelector('.sura-menu__toggle');

        toggle.addEventListener('click', () => {
          item.classList.contains('is-open') ? this.close(item) : this.open(item);
        });

        // Hover intent: short delays stop panels flickering as the pointer crosses the bar
        item.addEventListener('mouseenter', () => {
          if (!this.canHover.matches) return;
          clearTimeout(item._menuTimer);
          item._menuTimer = setTimeout(() => this.open(item), 80);
        });
        item.addEventListener('mouseleave', () => {
          if (!this.canHover.matches) return;
          clearTimeout(item._menuTimer);
          item._menuTimer = setTimeout(() => this.close(item), 160);
        });

        // Close when keyboard focus leaves the item and its panel
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) this.close(item);
        });
      });

      this.onKeydown = (e) => {
        if (e.key !== 'Escape') return;
        const open = this.querySelector('.sura-menu__item.is-open');
        if (!open) return;
        this.close(open);
        open.querySelector('.sura-menu__toggle').focus();
      };
      this.onDocClick = (e) => {
        if (!this.contains(e.target)) this.closeAll();
      };
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocClick);
    }

    open(item) {
      this.items.forEach((other) => { if (other !== item) this.close(other); });
      item.classList.add('is-open');
      item.querySelector('.sura-menu__toggle').setAttribute('aria-expanded', 'true');
    }

    close(item) {
      clearTimeout(item._menuTimer);
      item.classList.remove('is-open');
      item.querySelector('.sura-menu__toggle').setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.items.forEach((item) => this.close(item));
    }
  }

  customElements.define('sura-menu', SuraMenu);
}
